import { TwoColumnInfoList } from "@kohler-dsm-library/kohler-modules"
import React from "react"

export const TechnicalSpecificationsSection = () => {
  const twoColumnInfoListProps = {
    heading: {
      text: "Technical Specifications",
    },
    infoList: [
      { heading: { text: "Dimensions" }, copy: { text: '78" x 41" x 30"' } },
      {
        heading: { text: "Finishes & materials" },
        copy: { text: "Premium woodgrain panels and acrylic" },
      },
      {
        heading: { text: "What's included" },
        copy: {
          text: "Bath, cushioned headrest, insulated spa cover, integrated filling hose, and two 30-micron filters",
        },
      },
      {
        heading: { text: "Indoor/Outdoor installation" },
        copy: {
          text: "Can connect directly to the home's water supply line or be filled with an outdoor hose.",
        },
      },
      {
        heading: { text: "Adjustable temperature" },
        copy: {
          text: "Set the ideal water temperature, with the ability to go as low as 39°F",
        },
      },
      {
        heading: { text: "Adjustable ambient lighting" },
        copy: {
          text: "Choose from three temperature options for the bottom perimeter lighting to set the mood",
        },
      },
      {
        heading: { text: "Advanced water cleansing" },
        copy: {
          text: "A self-cleaning system with an incorporated UV light and a micron filter automatically cleanses the water",
        },
      },
      {
        heading: { text: "Control Panel" },
        copy: {
          text: "An Attractively concealed control panel allows easy adjustment of settings and maintenance of the Ice Bath.",
        },
      },
      {
        heading: { text: "Storage Space" },
        copy: {
          text: "Built-in storage space for neatly storing filter replacements and other cleaning supplies",
        },
      },
    ],
  }

  return (
    <TwoColumnInfoList
      mod="charcoal"
      component="section"
      {...twoColumnInfoListProps}
    />
  )
}
